__turbopack_context__.v({
  "abuse-error-wrapper": "index-module-scss-module__jIYupW__abuse-error-wrapper",
  "abuse-success-wrapper": "index-module-scss-module__jIYupW__abuse-success-wrapper",
  "ad-abuse-form": "index-module-scss-module__jIYupW__ad-abuse-form",
  "bounceIn": "index-module-scss-module__jIYupW__bounceIn",
  "collapse": "index-module-scss-module__jIYupW__collapse",
  "icon-check": "index-module-scss-module__jIYupW__icon-check",
  "privacy-link": "index-module-scss-module__jIYupW__privacy-link",
  "row-container": "index-module-scss-module__jIYupW__row-container",
  "send-error": "index-module-scss-module__jIYupW__send-error",
  "submit-wrapper": "index-module-scss-module__jIYupW__submit-wrapper",
  "text-area-wrapper": "index-module-scss-module__jIYupW__text-area-wrapper",
});
